import React from "react"

export const currentDateContext = React.createContext()